import { fields, createSchema, validate as _validate } from '..';

const { twoFactorCode } = fields;

const user = createSchema({
  code: twoFactorCode,
});

const validate = (data) => _validate(user, data);

export default validate;
